var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tabs"},[_c('ul',[_c('router-link',{attrs:{"exact":"","tag":"li","to":{ 
          name: 'section-manager', 
          params: { 
            standard: _vm.$route.params.standard,
            section: _vm.$route.params.section,
          }
        }}},[_c('a',[_vm._v("Checkpoints")])]),_c('router-link',{attrs:{"tag":"li","to":{ name: 'edit-section', params: { 
            standard: _vm.$route.params.standard,
            section: _vm.$route.params.section,
          }}}},[_c('a',[_vm._v("Edit")])])],1)]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }